import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "pr-x2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-12" }
const _hoisted_4 = { key: 0 }

import {
    BaseProductItem,
    ItemType,
    ItemMessageType,
    ModuleSofaConfigurationProductItem,
    OutletProductItem, PickAndPackProductItem,
} from '@/b2c/shared/api/server-apis';
import { computed } from 'vue';
import ItemMessages from '@/b2c/shared/checkout/ui/ItemMessages.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import GiftPackagingLineItemIsActivated from '@/shared/checkout/gift-packaging/ui/GiftPackagingLineItemIsActivated.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutItem',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: ModuleSofaConfigurationProductItem | OutletProductItem | PickAndPackProductItem | BaseProductItem;
}



const labels = useBlockLabels();

const isModuleSofaItem = computed(() => {
    return props.item.type === ItemType.ModuleSofa;
});

const isGiftPacked = computed(() => {
    return (props.item as PickAndPackProductItem).giftPackingMessage;
});

const itemMessages = computed(() => {
    return [...props.item.primaryItemMessages, ...props.item.secondaryItemMessages];
});


return (_ctx: any,_cache: any) => {
  const _component_ProductImage = _resolveComponent("ProductImage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isModuleSofaItem))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.item.image,
            class: "w-75"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createBlock(_component_ProductImage, {
            key: 1,
            sku: __props.item.sku,
            alt: __props.item.name,
            "aspect-ratio": 4/3,
            "width-on-screen": 1,
            class: "w-75"
          }, null, 8, ["sku", "alt"]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, _toDisplayString(__props.item.name), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).deliverableItemsItemCount, { quantity: __props.item.quantity })), 1),
      (__props.item.hub)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$dictionary.pluralize(__props.item.quantity, _unref(labels).deliverableItemsItemHubInfo, _unref(labels).deliverableItemsItemHubInfoPlural, { hub: __props.item.hub })), 1))
        : _createCommentVNode("", true),
      _createVNode(ItemMessages, {
        messages: _unref(itemMessages),
        type: _unref(ItemMessageType).CheckOut,
        class: "text-12"
      }, null, 8, ["messages", "type"]),
      _renderSlot(_ctx.$slots, "default"),
      (_unref(isGiftPacked))
        ? (_openBlock(), _createBlock(GiftPackagingLineItemIsActivated, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})